import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    Text,
    Spacer,
    Image,
    Flex,
} from '@zillow/constellation';

import KeepeIcon from 'app/shared/images/builder-icon-keepe.svg';
import HomeeIcon from 'app/shared/images/builder-icon-homee.jpg';

import { PropertiesSelectors } from 'app/shared/selectors';
import analyticsUtils from 'app/client/utils/analyticsUtils';
import AnalyticsConstants from 'app/shared/constants/AnalyticsConstants';

import {
    BannerButtonContainer,
    StyledContainer,
    ContentContainer,
    ButtonTryKeepe,
} from './StyledComponents';

const BannerMaintenance = () => {
    const dispatch = useDispatch();
    const {
        details: {
            referralUrl,
            id = '1', // from api- keepe - id =1 homee- id=2
            description,
            displayName,
            title,
        },
    } = useSelector(state => PropertiesSelectors.makeMaintenancePartner(state));

    useEffect(() => {
        const GAEvent = id === '1' ? AnalyticsConstants.GA_EVENTS.MAINTENANCE_BANNER_DISPLAYED_KEEPE :
            AnalyticsConstants.GA_EVENTS.MAINTENANCE_BANNER_DISPLAYED_HOMEE;

        dispatch(analyticsUtils.track.GAEventV2(GAEvent));
    });

    const handleCTAClick = () => {
        const GAEvent = id === '1' ? AnalyticsConstants.GA_EVENTS.MAINTENANCE_BANNER_CLICK_KEEPE :
            AnalyticsConstants.GA_EVENTS.MAINTENANCE_BANNER_CLICK_HOMEE;

        dispatch(analyticsUtils.track.GAEventV2(GAEvent));
        window.open(referralUrl, 'newTab');
    };

    return (
        <StyledContainer>
            <Spacer marginBottom="sm">
                <Flex display="flex">
                    <Spacer marginRight="sm">
                        {id === '1' ?
                            <Image src={KeepeIcon} alt="Keepe Icon" />
                            : <Image src={HomeeIcon} alt="HomeeIcon" />
                        }
                    </Spacer>
                    <ContentContainer>
                        <Spacer marginY="xs">
                            <Text fontType="bodySmallHeading">{title}</Text>
                        </Spacer>
                        <Text fontType="bodySmall">{description}</Text>
                    </ContentContainer>
                </Flex>
            </Spacer>
            <BannerButtonContainer>
                <ButtonTryKeepe
                    size="md"
                    onClick={handleCTAClick}
                >
                    {`Try ${displayName}`}
                </ButtonTryKeepe>
            </BannerButtonContainer>
        </StyledContainer>
    );
};

export default BannerMaintenance;
